import type { AddonGroup, AddonGroupDetail } from '@/domain/entities/addon-group.entity'
import type { AddonGroupDetailDto, AddonGroupDto } from './addon-group.dto'
import { modifierMapper } from './modifier.mapper'

export const addonGroupMapper = {
  toAddonGroup(dto: AddonGroupDto): AddonGroup {
    return {
      id: dto.id,
      name: dto.name,
      sku: dto.sku || null,
      // List biasa hanya memuat yang aktif; anggap aktif bila field absen.
      active: dto.active ?? true,
      addons: (dto.addons ?? []).map(modifierMapper.toModifier),
    }
  },

  toAddonGroupDetail(dto: AddonGroupDetailDto): AddonGroupDetail {
    return {
      ...addonGroupMapper.toAddonGroup(dto),
      productIds: dto.product_ids ?? [],
    }
  },
}
